import React, { useEffect, useState } from 'react';
import { useDispatch } from 'hooks/store';
import { usePagination } from 'hooks/pagination';
import {
  OrderItem,
  Organization,
  ProductionItem,
  SeedingBatch,
} from 'constants/interface';
import { DatePicker, Search, Table } from 'UI';
import {
  getSeedingBatchListAction,
} from 'state/slices/productionItem';
import {
  buildRegularProductDisplay,
  buildSimpleQuantityDisplay,
  buildTrayQuantityDisplay,
  getReservedQuantity,
  getTrayQuantity,
} from 'helpers/order';
import { buildTrayDisplay } from 'helpers/tray';
import { ProductTypeMapping } from 'constants/product';
import { GetSeedingBatchList } from 'api/seedingBatch';
import { unwrapResult } from '@reduxjs/toolkit';
import dayjs, { Dayjs } from 'dayjs';

import TableRowAction from './components/TableRowAction';

import {
  SearchContainer,
} from './style';

// const useDailySeedingBatchList = (date: Dayjs) => {

// }

interface SeedingProductionItemsTabProps {
  selectedOrg: Organization
}

const SeedingListTab = ({
  selectedOrg,
}: SeedingProductionItemsTabProps): JSX.Element => {
  const dispatch = useDispatch();

  const [selectedDate, setSelectedDate] = useState<string>(dayjs().format());
  const [seedingBatchList, setSeedingBatchList] = useState<SeedingBatch[]>();
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (selectedDate) {
      const paginationData: GetSeedingBatchList = {
        isPaginated: false,
        seedingDate: selectedDate,
      };
      // Fetch
      (async () => {
        setLoading(true);
        const result = await dispatch(getSeedingBatchListAction({
          ...paginationData,
          isPaginated: false,
        }));
        setLoading(false);
        const { data } = unwrapResult(result);
        setSeedingBatchList(data);
      })();
    } else {
      setSeedingBatchList(undefined);
    }
  }, [selectedDate, dispatch, setSeedingBatchList]);

  // TODO: should paginate or just show list?
  // const internalFetch = (paginationData: GetSeedingBatchList) => {};

  // async (
  //   paginationData: GetSeedingBatchList,
  // ) => {
  //   dispatch(getSeedingBatchListAction({
  //     ...paginationData,
  //     isPaginated: false,
  //   }));
  // };
  // const pagination = usePagination<SeedingBatch>(
  //   internalFetch,
  //   {
  //     initialTotal: seedingBatchList?.length,
  //   },
  // );

  // useEffect(() => {
  //   dispatch(cleanProductionItemsAction());
  // }, []);

  // useEffect(() => {
  //   pagination.updateTotal(remoteTotal);
  // }, [remoteTotal]);

  // const sorter = (): number => 0;

  // const pageData = pagination.getInternal();

  // const orderTypeFilter = pageData.filter.type ?? null;
  // const orderStatusFilter = pageData.filter.status ?? null;

  // const statusFilterList = [
  //   ...Object.values(OrderProposalStatusEnum),
  //   ...Object.values(OrderProductionStatusEnum),
  //   ...Object.values(OrderOtherStatusEnum),
  // ];

  return (
    <>
      <SearchContainer>
        <DatePicker
          allowClear={false}
          defaultValue={dayjs(selectedDate)}
          showTime={false}
          onSelect={(value) => {
            setSelectedDate(value.format());
          }}
        />
      </SearchContainer>
      <Table<SeedingBatch>
        rowKey="id"
        dataSource={seedingBatchList}
        pagination={false}
        loading={isLoading}
        showSorterTooltip={false}
        locale={{
          filterReset: 'Limpar',
          cancelSort: 'Clique para limpar ordenação',
          triggerAsc: 'Clique para ordem crescente',
          triggerDesc: 'Clique para ordem decrescente',
        }}
        // onChange={pagination.onTableChange}
      >
        {/* TODO: add link to order root page? */}
        <Table.Column
          title="Pedido"
          key="orderSeq"
          dataIndex="productionItem"
          render={(
            productionItem: ProductionItem,
          ) => productionItem.orderItem.order.seq}
        />
        <Table.Column
          title="Cliente"
          key="client"
          dataIndex="productionItem"
          render={(
            productionItem: ProductionItem,
          ) => productionItem.orderItem.order.client.name}
        />
        <Table.Column
          title="Produto"
          key="product"
          dataIndex="productionItem"
          render={(
            productionItem: ProductionItem,
          ) => {
            const display = buildRegularProductDisplay(productionItem, {
              quantity: false,
              tray: false,
            });
            return display;
          }}
        />
        <Table.Column
          title="Tipo Bdj"
          key="tray"
          dataIndex="productionItem"
          render={(
            productionItem: ProductionItem,
          ) => {
            const display = buildTrayDisplay(productionItem.tray);
            return display;
          }}
        />
        <Table.Column
          title="Formação"
          key="type"
          dataIndex="productionItem"
          // filters={Object.values(OrderTypeEnum).map((orderType) => ({
          //   text: OrderTypeDisplayMapping[orderType].name,
          //   value: orderType,
          // }))}
          // filterMultiple={false}
          // filteredValue={orderTypeFilter !== null ? [orderTypeFilter] : null}
          render={(productionItem: ProductionItem) => {
            const displayName = ProductTypeMapping[productionItem.product.type];
            return displayName;
          }}
        />
        <Table.Column
          title="Quantidade Mudas"
          key="reservedQuantity"
          dataIndex="productionItem"
          // filters={Object.values(OrderTypeEnum).map((orderType) => ({
          //   text: OrderTypeDisplayMapping[orderType].name,
          //   value: orderType,
          // }))}
          // filterMultiple={false}
          // filteredValue={orderTypeFilter !== null ? [orderTypeFilter] : null}
          render={(productionItem: ProductionItem) => {
            // const display = buildSimpleQuantityDisplay(calculatedQuantity);
            // const display = buildSimpleQuantityDisplay(getSeedingBatchQuantity(seedingBatch));
            const display = buildSimpleQuantityDisplay(getReservedQuantity(productionItem));
            return display;
          }}
        />
        <Table.Column
          title="Quantidade Bdj Programada"
          key="reservedQuantityTray"
          dataIndex="productionItem"
          // filters={Object.values(OrderTypeEnum).map((orderType) => ({
          //   text: OrderTypeDisplayMapping[orderType].name,
          //   value: orderType,
          // }))}
          // filterMultiple={false}
          // filteredValue={orderTypeFilter !== null ? [orderTypeFilter] : null}
          render={(productionItem: ProductionItem) => {
            // const display = buildSimpleQuantityDisplay(calculatedQuantity);
            // const display = buildSimpleQuantityDisplay(getSeedingBatchQuantity(seedingBatch));
            const display = buildTrayQuantityDisplay(getTrayQuantity(
              getReservedQuantity(productionItem),
              productionItem.tray.capacity,
              productionItem.seedConsumption,
            ));
            return display;
          }}
        />
        {/* <Table.Column
          title=""
          key="action"
          dataIndex="id"
          render={(id: string, record: ProductionItem) => {
            const actionButton = (
              <TableRowAction
                item={record}
                // index={index}
                // onVisibleChange={(visibleIndex) => setCurrentActiveAction(visibleIndex)}
              />
            );
            return actionButton;
          }}
        /> */}
      </Table>
    </>
  );
};

export default SeedingListTab;
